<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 10.5C12.0014 13.5086 14.8333 16.3333 16.5 17C10.1 17 7 14.6547 5 13.5C3 12.3453 0 8.5 0 8.5L0.5 0H11V2V4V4.5C11 5.5 11 7.5 11.5 10.5Z" fill="white"/>
</svg>
